import { SERVER_URL } from "@/config"
import store from "@/store"
import { Configuration } from "@vitable/asclepius-api-client-ts"

let _apiClientConfig = undefined

function _handleApiError(error, vueComponent) {
  console.error(error)

  if (error.response && error.response.data && error.response.data.error) {
    vueComponent.$message({
      message: error.response.data.error,
      type: "error"
    })
  } else {
    vueComponent.$message({
      message: "An unexpected error occurred, please contact the dev team at dev@vitablehealth.com.",
      type: "error"
    })
  }
}

export function getApiErrorMessage(error) {
  if (error.response && error.response.data) {
    if (error.response.data.error) return error.response.data.error
    else if (error.response.data.detail) return error.response.data.detail
  }

  return "An unexpected error occurred, please notify your supervisor"
}

export async function callApi(requestPromise, vueComponent = null) {
  try {
    return (await requestPromise()).data
  } catch (e) {
    if (vueComponent) {
      _handleApiError(e, vueComponent)
    }
    console.error(e)
    throw e
  }
}

// ToDo - WARNING:
// Do not call this function in the top level of an ES6 Module.
// 1. The fetched token will eventually become stale, and cause a 401.
// 2. The application will then trigger the me/logout action. This will NOT destroy the Module.
// 3. The module will continue to use the expired token from the stale apiClientConfig() call.
export function apiClientConfig() {
  const token = store.getters["me/token"]
  _apiClientConfig = token
    ? (_apiClientConfig = new Configuration({
        basePath: SERVER_URL,
        baseOptions: {
          headers: {
            Authorization: token
          }
        }
      }))
    : (_apiClientConfig = new Configuration({
        basePath: SERVER_URL
      }))
  return _apiClientConfig
}
